export { AmericanNewCardDetail } from "./AmericanNewCardDetail";
